export const locales: ['en', 'de', 'fr', 'nl', 'debug'] = [
  'en',
  'de',
  'fr',
  'nl',
  'debug',
]

export type Locale = (typeof locales)[number]

function isLocale(locale: unknown): locale is Locale {
  return locales.includes(<Locale>locale)
}

/**
 * Parses a raw locale string to a valid locale string.
 * If input is not a known locale ('en', 'de', 'fr', 'nl') it returns the fallback locale ('de')
 */
export function toLocale(rawLocale?: string | null) {
  return isLocale(rawLocale) ? rawLocale : 'de'
}

const cookieKey = 'easybell-locale'

function getCookieDomain(): string | null {
  const { hostname } = window.location

  if (hostname.endsWith('easybell.de')) return '.easybell.de'
  if (hostname.endsWith('easybell.com')) return '.easybell.com'

  return null
}

function readLocaleCookie(): string | null {
  const match = document.cookie
    .split('; ')
    .find((c) => c.startsWith(`${cookieKey}=`))

  return match ? decodeURIComponent(match.slice(cookieKey.length + 1)) : null
}

export function loadLocale(): Locale {
  const rawLocale = readLocaleCookie()

  return toLocale(rawLocale)
}

export function saveLocale(locale: Locale) {
  const domain = getCookieDomain()
  const domainPart = domain ? `; domain=${domain}` : ''

  document.cookie = `${cookieKey}=${encodeURIComponent(locale)}; path=/${domainPart}; max-age=${60 * 60 * 24 * 365}`
}
